import { ItemConfig } from './types'

const CM_PX = 78.7

const sizes = {
  S: 0.846,
  M: 0.897,
  L: 0.948,
  XL: 1,
}

export const UA_521401_PARKER_CONFIG: ItemConfig = {
  name: 'United Athle 10.0オンス スウェット プルオーバー パーカ(パイル)',
  vendor: 'キャブ',
  vendor_code: '521401',
  printable_sections: ['103', '105'],
  colors: [
    { name: 'ホワイト', hex: '#FFFFFF', system_id: '001', item_id: 59 },
    { name: 'ナチュラル', hex: '#FFFFFF', system_id: '019', item_id: 59 },
    { name: 'ライトピンク', hex: '#FFFFFF', system_id: '495', item_id: 59 },
    { name: 'チャコール', hex: '#FFFFFF', system_id: '007', item_id: 60 },
    { name: 'ダークブラウン', hex: '#FFFFFF', system_id: '052', item_id: 60 },
    { name: 'パープル', hex: '#FFFFFF', system_id: '062', item_id: 60 },
    { name: 'レッド', hex: '#FFFFFF', system_id: '069', item_id: 60 },
    { name: 'ロイヤルブルー', hex: '#FFFFFF', system_id: '085', item_id: 60 },
    { name: 'ネイビー', hex: '#FFFFFF', system_id: '086', item_id: 60 },
    { name: 'ブラック', hex: '#FFFFFF', system_id: '002', item_id: 60 },
    { name: 'ミックスグレー', hex: '#FFFFFF', system_id: '006', item_id: 60 },
    { name: 'アイビーグリーン', hex: '#FFFFFF', system_id: '497', item_id: 60 },
    { name: 'オレンジ', hex: '#FFFFFF', system_id: '064', item_id: 60 },
    { name: 'ゴールド', hex: '#FFFFFF', system_id: '022', item_id: 60 },
  ],
  sizes: ['S', 'M', 'L', 'XL'],
  sections: [
    {
      name: '胸中央',
      id: '103',
      config: {
        width: 2125,
        height: 1574,
      },
    },
    {
      name: '左胸',
      id: '101',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右胸',
      id: '102',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '背中中央',
      id: '105',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '襟下',
      id: '109',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '左袖',
      id: '107',
      config: {
        width: 787,
        height: 2754,
      },
    },
    {
      name: '右袖',
      id: '108',
      config: {
        width: 787,
        height: 2754,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: 8200,
      height: 8200,
      origin: { x: 8200 / 2, y: 8200 * 0.32 },
      sizes: sizes,
      sections: [
        {
          id: '103',
          offset: {
            x: -(2125 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '101',
          offset: {
            x: 5 * CM_PX,
            y: 6 * CM_PX,
          },
        },
        {
          id: '102',
          offset: {
            y: 6 * CM_PX,
            x: -(5 * CM_PX + 787),
          },
        },
      ],
    },
    {
      name: 'back',
      width: 8200,
      height: 8200,
      origin: { x: 8200 / 2, y: 8200 * 0.19 },
      sizes: sizes,
      sections: [
        {
          id: '105',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '109',
          offset: {
            x: -(787 / 2),
            y: 2.5 * CM_PX,
          },
        },
      ],
    },
    {
      name: 'left',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3494 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '107',
          offset: {
            y: -(2 * CM_PX + 787),
            x: -(787 / 2),
          },
        },
      ],
    },
    {
      name: 'right',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3494 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '108',
          offset: { y: -(2 * CM_PX + 787), x: -(787 / 2) },
        },
      ],
    },
  ],
}
